var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCaseStudies(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 48,
    viewBox: "0 0 107 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 34.3C11.0359 34 9.6695 14.6333 24 13.7333V0C-7.09386 0.966667 -8.8935 46.2 24 48V34.3Z",
    fill: "#082C4E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 13.7C36.9641 14 38.3305 33.3667 24 34.2667L24 48C55.0939 47.0333 56.8935 1.8 24 2.09815e-06L24 13.7Z",
    fill: "#FE6571"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M82 48C49.6106 47.0333 47.7359 1.8 82 0V48Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M82 2.18557e-06C114.389 0.966666 116.264 46.2 82 48L82 2.18557e-06Z",
    fill: "#FFCC00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaseStudies);
export default __webpack_public_path__ + "static/media/case-studies.145a346d89b386c9efd2f2004182bc1a.svg";
export { ForwardRef as ReactComponent };